var map = {
	"./Logo_delestrez_by.svg": 9127,
	"./Logo_durand_by.svg": 2881,
	"./Logo_guiproman_by.svg": 5981,
	"./Logo_marceul_by.svg": 4514,
	"./Logo_ved_by.svg": 6084,
	"./Logo_vesoul_by.svg": 1047
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2805;